import COMMENT from 'constants/comment';

export const addActionToComment = ({
  action,
  commentId,
  commentPages,
  handleActionCallback,
}) =>
  commentPages.map((commentPage) =>
    commentPage.map((comment) => {
      if (comment.commentId === commentId) {
        return handleActionCallback(comment, action);
      }

      const newComment = comment;

      newComment.replies = newComment.replies.map((reply) =>
        reply.commentId === commentId
          ? handleActionCallback(reply, action)
          : reply
      );

      return newComment;
    })
  );

export const isCommentContentBlocked = (commentStatusName) =>
  commentStatusName === COMMENT.STATUSES.REMOVED_BY_ADMIN ||
  commentStatusName === COMMENT.STATUSES.REMOVED_BY_USER ||
  commentStatusName === COMMENT.STATUSES.REMOVED_FOR_ALL;

export const isCommentDisliked = (comment, ratings) =>
  !!comment?.isDisliked ||
  !!ratings?.dislikes.some((commentId) => commentId === comment.commentId);

export const isCommentLiked = (comment, ratings) =>
  !!comment?.isLiked ||
  !!ratings?.likes.some((commentId) => commentId === comment.commentId);

// These statuses are only visible for the user who posted them
const isCommentVisible = ({ commentStatusName }) =>
  commentStatusName === COMMENT.STATUSES.WAITING ||
  commentStatusName === COMMENT.STATUSES.PROCESSING ||
  commentStatusName === COMMENT.STATUSES.REMOVED_BY_ADMIN;

export const isReplyFromTheSameUserOfParent = ({ replies, userId }) =>
  replies[0].userId === userId && isCommentVisible(replies[0]);

export const getCommentIdFromHash = (hash) => {
  if (hash && hash.includes('comment')) {
    try {
      const [hashId] = hash.match(/([0-9]+)/g);

      return Number(hashId);
    } catch (e) {
      return null;
    }
  }

  return null;
};

// The `initialCommentCount` must be summed with the comments that
// only the user can see so we make sure to show the same
// comments count of comments that the user can actually access
export const getCommentsCount = (initialCommentCount, comments) =>
  initialCommentCount +
  getUserExclusiveRepliesCount(comments) +
  getUserExclusiveParentsCount(comments);

export const getDislikedComment = (comment, action) => {
  const newComment = comment;

  if (action === COMMENT.ACTIONS.DISLIKE) {
    if (newComment.commentLikes > 0 && comment.isLiked) {
      newComment.commentLikes -= 1;
    }

    newComment.isLiked = false;
    newComment.isDisliked = true;
  }

  if (action === COMMENT.ACTIONS.REMOVE) {
    newComment.isDisliked = false;
  }

  return newComment;
};

export const getLikedComment = (comment, action) => {
  const newComment = comment;

  if (action === COMMENT.ACTIONS.LIKE) {
    newComment.commentLikes += 1;
    newComment.isLiked = true;
    newComment.isDisliked = false;
  }

  if (action === COMMENT.ACTIONS.REMOVE) {
    newComment.commentLikes -= 1;
    newComment.isLiked = false;
  }

  return newComment;
};

const getUserExclusiveRepliesCount = (comments) => {
  if (!comments.replies) {
    return 0;
  }

  return comments
    .map(({ replies }) => replies.filter(isCommentVisible).length)
    .reduce((a, b) => a + b, 0);
};

const getUserExclusiveParentsCount = (comments) =>
  comments
    .map(
      (comment) =>
        comment?.replies &&
        (!hasReply(comment) || isReplyFromTheSameUserOfParent(comment)) &&
        isCommentVisible(comment)
    )
    .reduce((a, b) => a + b, 0);

export const hasReply = ({ replies }) => replies?.length > 0;

export const toFormattedCommentCount = (length) => {
  if (length === 0 || !length) return COMMENT.COUNT_FORMAT.NO_COMMENTS;
  if (length === 1) return COMMENT.COUNT_FORMAT.ONE_COMMENT;

  return `${length} ${COMMENT.COUNT_FORMAT.COMMENTS}`;
};
